//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetNumOperations",{R_:{num_operations:''}},0,0],[["operation","slide_height"],"SetOperationSlideHeight",{},2,0],[["operation","lift_start_angle","lift_stop_angle","lift_to_dist","lock_at_dist"],"SetOperationCushionSettings",{},5,0],[["operation","vals"],"SetOperationUserTransportCurves",{},2,0],[["operation","curve_set"],"SetOperationTransportCurveSet",{},2,0],[["operation","ventilation_lift_distance","ventilation_lift_stay","binder_way_lift_distance","binder_way_lift_duration","upper_limit","lower_limit"],"SetOperationCushionSettings2",{},7,0]],[]];
SPLM.Die.PressModel = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.PressModel";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;